package one.healthium.ui.components

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import one.healthium.domain.common.Animations
import one.healthium.domain.common.CtaConfig
import one.healthium.ui.common.utils.toShimmeringConfig
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults.appButtonColors
import one.healthium.ui.compose.components.appShimmer
import one.healthium.ui.compose.modifier.onClickHaptic

@Composable
fun CtaButton(
    modifier: Modifier = Modifier,
    onClick: () -> Unit,
    text: String?,
    ctaConfig: CtaConfig? = null,
    enabled: Boolean = true,
) {
    CtaButton(
        modifier = modifier,
        onClick = onClick,
        enabled = enabled,
        ctaConfig = ctaConfig,
    ) {
        Text(text ?: "Continue")
    }
}

@Composable
fun CtaButton(
    modifier: Modifier = Modifier,
    onClick: () -> Unit,
    animations: Animations? = null,
    ctaConfig: CtaConfig? = null,
    enabled: Boolean = true,
    content: @Composable () -> Unit,
) {
    val colors = if (ctaConfig?.backgroundColor != null) {
        CtaButtonDefaults.fromColorModel(ctaConfig.backgroundColor)
    } else {
        null
    }
    AppButton(
        modifier = modifier
            .testTag("cta_button")
            .then(
                if (animations != null) {
                    when (ctaConfig?.animationKey) {
                        "shimmering" -> Modifier.appShimmer(animations.shimmering?.toShimmeringConfig())
                        else -> Modifier
                    }
                } else {
                    Modifier
                }
            ),
        onClick = onClickHaptic(onClick),
        enabled = enabled,
        colors = colors
    ) {
        content()
    }
}


object CtaButtonDefaults {
    @Composable
    fun fromColorModel(colorModel: one.healthium.domain.common.Color): ButtonColors {
        val colorValue = if (isSystemInDarkTheme()) colorModel.dark else colorModel.light
        val color = if (colorValue != null) {
            Color(colorValue)
        } else {
            Color.Unspecified

        }
        return appButtonColors(containerColor = color)
    }
}
